import { useState } from "react";
import { Workflow } from "lucide-react";

const DIAGRAMS = [
  {
    id: "spark-to-scale-detailed",
    title: "Spark to Scale — Full Process",
    caption: "Labs → Production Pod → Adoption, with Approve / Iterate / Reject flows, shared roles and outcomes.",
    url: "https://customer-assets-v7afamib.emergentagent.net/job_idea-orchestrator-3/artifacts/suyfdmmj_image.webp",
  },
  {
    id: "spark-to-scale-journey",
    title: "Spark to Scale — Journey & Turnaround",
    caption: "The 5-step journey from Anywhere to Product, with turnaround times and key principles.",
    url: "https://customer-assets-v7afamib.emergentagent.net/job_idea-orchestrator-3/artifacts/u7zpb8g6_image.webp",
  },
];

export default function Process() {
  const [zoom, setZoom] = useState(null);

  return (
    <div className="p-6 max-w-6xl">
      <header className="mb-6">
        <h1 className="font-heading text-4xl font-black tracking-tighter flex items-center gap-3">
          <Workflow className="w-8 h-8 text-primary" /> Process Reference
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          The original VLink Labs "Spark to Scale" framework this orchestrator enforces. Click a diagram to view it full-size.
        </p>
      </header>

      <div className="space-y-6">
        {DIAGRAMS.map((d) => (
          <figure key={d.id} data-testid={`process-diagram-${d.id}`} className="border border-border bg-card rounded-sm overflow-hidden">
            <figcaption className="flex items-center justify-between px-4 py-3 border-b border-border">
              <span className="font-heading font-bold tracking-tight">{d.title}</span>
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Reference</span>
            </figcaption>
            <button
              onClick={() => setZoom(d)}
              data-testid={`process-open-${d.id}`}
              className="block w-full bg-white/95 p-4 hover:bg-white transition-colors duration-200"
            >
              <img src={d.url} alt={d.title} className="w-full h-auto rounded-sm" loading="lazy" />
            </button>
            <p className="text-xs text-muted-foreground px-4 py-3">{d.caption}</p>
          </figure>
        ))}
      </div>

      {zoom && (
        <div
          data-testid="process-lightbox"
          onClick={() => setZoom(null)}
          className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-6 cursor-zoom-out"
        >
          <img src={zoom.url} alt={zoom.title} className="max-w-full max-h-full rounded-sm bg-white" />
        </div>
      )}
    </div>
  );
}
